import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { Collection, CollectionDetail } from "../../lib/types";

export const useCollections = (search: string) =>
	useQuery({
		queryKey: ["collections", search],
		queryFn: () =>
			api.get<{ items: Collection[] }>(
				`/api/collections${search ? `?q=${encodeURIComponent(search)}` : ""}`,
			),
	});

export const useCollection = (collectionId: string | undefined) =>
	useQuery({
		queryKey: ["collection", collectionId],
		queryFn: () => api.get<CollectionDetail>(`/api/collections/${collectionId}`),
		enabled: Boolean(collectionId),
	});
